export const getPercent = (value, maxValue) => {
  const percent = (maxValue * 100) / value
  if (percent % 10 === 0) return percent
  return percent.toFixed(2)
}
